import Vue from 'vue'
import {isFullWidth} from "@/common/helpers/validation";

Vue.directive('remove-if-fullwidth', function (el, binding, vnode) {
    const handler = function (e) {
        const valueInput = e.target.value;
        if (isFullWidth(valueInput)) {
            e.target.value = '';
            vnode.elm.dispatchEvent(new CustomEvent('input'));
        }
    };
    el.addEventListener('input', handler)
});
